export function snakeCase(value) {
    return value
        .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
        .replace(/([a-zA-Z])([0-9])/g, '$1_$2')
        .replace(/[\s-]+/g, '_')
        .toLowerCase();
}
export function toDbKeys(obj) {
    const result = {};
    for (const [key, value] of Object.entries(obj)) {
        if (value === undefined) {
            continue;
        }
        result[snakeCase(key)] = value;
    }
    return result;
}
function camelCase(value) {
    return value.replace(/_([a-z0-9])/g, (_, c) => c.toUpperCase());
}
const JSONB_CONTENT_FIELDS = new Set([
    'config',
    'payload',
    'output',
    'metadata',
    'data',
    'settings',
    'options',
    'headers',
    'body',
    'modelVoices',
]);
function isJsonbContentField(key) {
    return JSONB_CONTENT_FIELDS.has(key);
}
function transformValue(value, parentKey) {
    if (parentKey && isJsonbContentField(parentKey)) {
        return value;
    }
    if (Array.isArray(value)) {
        return value.map((entry) => transformValue(entry, parentKey));
    }
    if (value && typeof value === 'object') {
        return fromDbKeys(value);
    }
    return value;
}
export function fromDbKeys(value) {
    if (Array.isArray(value)) {
        return value.map((entry) => fromDbKeys(entry));
    }
    const result = {};
    for (const [key, val] of Object.entries(value)) {
        const camelKey = camelCase(key);
        result[camelKey] = transformValue(val, camelKey);
    }
    return result;
}
//# sourceMappingURL=db-keys.js.map